import { Injectable, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { MappingService } from './mapping.service';

@Injectable()
export class AlertService implements OnDestroy {
  private subscriptions: Subscription = new Subscription();

  constructor(private mappingService: MappingService) {}

  getImageByType(type: string): string {
    let response = '';

    const { types } = this.mappingService.list.value.alert;
    const index = types.findIndex((t) => t.name === type);

    if (index >= 0) {
      response = types[index].imgUrl;
    } else {
      const indexTMP = _.findIndex(
        types,
        function (chr: any) {
          return chr.name == 'AndOr';
        },
        0
      );

      response = types[indexTMP].imgUrl;
    }

    return response;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
